// src/store/modules/imageStore.js
import PouchDB from 'pouchdb';
const config = require('@/config');
import { Filesystem, Directory } from '@capacitor/filesystem';
import {isPlatform} from "@ionic/vue";
import { Capacitor } from '@capacitor/core';
const db = new PouchDB(config.conference +'_v3')

function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(',')[1]; // remove data:*/*;base64,
            resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

function getAttachmentName(url) {
    return url.split('/').pop() || 'image';
}

const namespaced = true
const state = {
    images: {}, // { docId: base64Data }
}
const mutations = {
    setImage(state, {docId, base64}) {
        state.images[docId] = base64;
    }
}
const actions = {


    async downloadFile({},imageUrl){
        const fileName = `test-${Date.now()}.png`;

        try {
            const result = await Filesystem.downloadFile({
                url: imageUrl,
                path: fileName,
                directory: Directory.Cache,
            });

            console.log('Download result:', result);


            const fullPath = result.path; // e.g. file:///Users/.../test-1750931044007.png
            const relativePath = fullPath.split('/').pop(); // 'test-1750931044007.png'
            if (!result.path) throw new Error('No path returned');

            const fileData = await Filesystem.readFile({
                path: relativePath,
                directory: Directory.Cache,
            });

            console.log('File base64 length:', fileData.data.length);
            return fileData.data;
        } catch (e) {
            console.error('Download error:', e);
        }
    },
    async fetchImage({ dispatch}, { docId, imageUrl }) {
        try {
            const attachmentName = getAttachmentName(imageUrl);

            // Try to get the existing image document
            try {
                const doc = await db.get(docId);
                const attachment = await db.getAttachment(docId, attachmentName);
                const base64 = await blobToBase64(attachment);
                const contentType = attachment.type;

                console.log('FROM DB')
                return `data:${contentType};base64,${base64}`;
            } catch (err) {
                if (err.status !== 404) throw err; // actual error
            }

            // Download from S3
            let response;
            let blob;
            let contentType = 'image/jpeg'; // default fallback
            let base64;
            
            // Use Capacitor's native platform detection - more reliable than isPlatform
            const platform = Capacitor.getPlatform();
            const isNativeMobile = platform === 'ios' || platform === 'android';
            console.log('Platform check - Capacitor platform:', platform, 'isNativeMobile:', isNativeMobile, 'URL:', imageUrl);
            
            if (!isNativeMobile) {
                // Browser environment (web) - use fetch
                try {
                    console.log('Using fetch for browser environment');
                    response = await fetch(imageUrl, {
                        mode: 'cors',
                        credentials: 'omit'
                    });
                    if (!response.ok) throw new Error('Image download failed');
                    blob = await response.blob();
                    contentType = blob.type || 'image/jpeg'; // fallback
                    base64 = await blobToBase64(blob);
                } catch (fetchErr) {
                    console.warn('Image load failed (CORS or network error), PDF will continue without this image:', imageUrl);
                    console.debug('Error details:', fetchErr);
                    return null; // Return null if CORS blocks the request - PDF generation will continue
                }
            } else {
                // Mobile environment - use Capacitor Filesystem
                try {
                    console.log('Using Capacitor downloadFile for mobile');
                    base64 = await dispatch('downloadFile', imageUrl);
                    if (!base64) {
                        console.warn('downloadFile returned null/undefined for:', imageUrl);
                        return null;
                    }
                } catch (downloadErr) {
                    console.warn('Mobile download error, returning null:', imageUrl, downloadErr);
                    return null;
                }
            }

            const dataUrl = `data:${contentType};base64,${base64}`;

            // Store in PouchDB
            const newDoc = {
                _id: docId,
                _attachments: {
                    [attachmentName]: {
                        content_type: contentType,
                        data: base64,
                    },
                },
            };

            try {
                await db.put(newDoc);
            } catch (err) {
                if (err.status === 409) {
                    const existingDoc = await db.get(docId);
                    await db.put({
                        ...existingDoc,
                        _attachments: {
                            ...(existingDoc._attachments || {}),
                            [attachmentName]: {
                                content_type: contentType,
                                data: base64,
                            },
                        },
                    });
                } else {
                    throw err;
                }
            }
            console.log('FROM FETCH')
            return dataUrl;
        } catch (err) {
            console.error('Failed to fetch/store image:', err);
            return null;
        }
    },
}

export const imageStore = {
    namespaced,
    state,
    mutations,
    actions
}

